import {
  salonModerationResultSchema,
  salonNoteSchema,
  salonNotesResponseSchema,
  salonRemindersResponseSchema,
  salonPlanGrantResultSchema,
  salonsResponseSchema,
  type SalonModerationRequest,
  type SalonModerationResult,
  type SalonNote,
  type SalonNoteCreateRequest,
  type SalonNotesResponse,
  type SalonNoteUpdateRequest,
  type SalonRemindersResponse,
  type SalonPlanGrantRequest,
  type SalonPlanGrantResult,
  type SalonsResponse,
} from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'

export function fetchSalons(options: { refresh?: boolean; signal?: AbortSignal } = {}): Promise<SalonsResponse> {
  const suffix = options.refresh ? '?refresh=true' : ''

  return apiRequest(`/salons${suffix}`, { schema: salonsResponseSchema, signal: options.signal })
}

export const moderateSalon = (id: number, request: SalonModerationRequest): Promise<SalonModerationResult> =>
  apiRequest(`/salons/${id}/moderation`, { method: 'POST', body: request, schema: salonModerationResultSchema })

export const grantPlan = (id: number, request: SalonPlanGrantRequest): Promise<SalonPlanGrantResult> =>
  apiRequest(`/salons/${id}/plan-grant`, { method: 'POST', body: request, schema: salonPlanGrantResultSchema })

export const fetchSalonNotes = (signal?: AbortSignal): Promise<SalonNotesResponse> =>
  apiRequest('/salon-notes', { schema: salonNotesResponseSchema, signal })

export const createSalonNote = (request: SalonNoteCreateRequest): Promise<SalonNote> =>
  apiRequest('/salon-notes', { method: 'POST', body: request, schema: salonNoteSchema })

export const updateSalonNote = (id: string, request: SalonNoteUpdateRequest): Promise<SalonNote> =>
  apiRequest(`/salon-notes/${id}`, { method: 'PATCH', body: request, schema: salonNoteSchema })

export const fetchDueReminders = (signal?: AbortSignal): Promise<SalonRemindersResponse> =>
  apiRequest('/salon-notes/reminders', { schema: salonRemindersResponseSchema, signal })

export const deleteSalonNote = (id: string): Promise<void> => apiRequest(`/salon-notes/${id}`, { method: 'DELETE' })
